import { render, staticRenderFns } from "./orgcomment.vue?vue&type=template&id=0157e1c5&"
import script from "./orgcomment.vue?vue&type=script&lang=js&"
export * from "./orgcomment.vue?vue&type=script&lang=js&"
import style0 from "./orgcomment.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports